import React from "react";
import { Tooltip as TooltipBase, TooltipProps } from "antd";
import TooltipSVG from "./tooltip.svg";
import { classNames } from "@features/utils/reactFunctions";

import * as style from "./TooltipStyle.module.scss"

type Props = TooltipProps & {
  title: React.ReactNode;
  tooltipMessage: React.ReactNode;
  className?: string;
};
const Tooltip = ({ title, tooltipMessage, className, ...rest }: Props) => (
  <div className={classNames(style.tooltip, className)}>
    <span className={style.title}>{title}</span>
    <TooltipBase
      title={tooltipMessage}
      getTooltipContainer={(triggerNode) =>
        triggerNode.parentElement ?? triggerNode
      }
      placement="bottom"
      {...rest}
    >
      <TooltipSVG />
    </TooltipBase>
  </div>
);

export default Tooltip;
